import barba from '@barba/core';
import gsap from 'gsap';
import Swiper from 'swiper/bundle';
import Cookies from 'js-cookie';
import PerfectScrollbar from 'perfect-scrollbar';
import scrollLock from 'scroll-lock';
import { addFillGapTarget, addFillGapSelector } from 'scroll-lock';
import clientTabs from './components/client-tabs';
import prepareAnimation from './components/prepare-animation';
import clientGallery from './components/client-gallery';
import loadMore from './components/loadMore';
import mainSlider from './components/main-slider';
import contactMap from './components/contact-map';
import _ from 'lodash.throttle';
import throttle from 'lodash.throttle';
import homeOpacity from './pages/home-page';
import clientList from './components/client-list';
import newsTopInfo from './components/news-top-info'
import video from './components/video';
import orientationModal from './components/orientation-modal';
import playIframe from './components/playIframe';

import scrollReveal from './helpers/scroll-reveal';
import newsVideo from './components/newsVideo';
import checkViewport from './components/checkViewport';
import aboutHeader from './components/aboutHeader';
import NewsSingle from './pages/news';
import animation from './components/animation';
export default () => {
  addFillGapSelector('.main-header, .cookie-block'); // fix scroll lock width reflow

  barbaInit();
  checkViewport();
  menu();
  search();
  pageLoad();
  playIframe();
    
  function barbaInit() {
    const TIMING_TRANSITION = 1;

    barba.init({
      // debug: true,
      timeout: 10000,
      cacheIgnore: true,
      prevent: ({ el }) => el.classList && el.classList.contains('ab-item'),
      transitions: [
        {
          leave(data) {
            const done = this.async();

            let menuBlock = document.getElementById('menu');
            let searchBlock = document.getElementById('search');
            let menuInner = menuBlock.querySelector('.menu-block__inner');

            if (searchBlock.classList.contains('open-menu')) {
              closeMenu('search');
              openMenu('menu');
            } else if (menuBlock.classList.contains('open-menu')) {
              closeMenu('all');

              const ps = new PerfectScrollbar(menuInner);
            }

            gsap
              .to(data.current.container, {
                opacity: 0,
                ease: 'power1',
                duration: TIMING_TRANSITION,
              })
              .eventCallback('onComplete', function () {
                done();
              });
          },

          beforeEnter(data) {
            data.current.container.remove();
            window.scrollTo(0, 0);
            pageLoad();

            let namespace = data.next.namespace;
            document.body.dataset.pageName = namespace;
            let header = document.querySelector('.main-header');

            if (namespace === 'About-Us') {
              header.classList.remove('white');
              header.classList.add('transparent');
            } else {
              header.classList.add('white');
              header.classList.remove('transparent');
            }
          },

          enter(data) {
            window.scrollTo(0, 0);
            const done = this.async();

            checkViewport();
            aboutHeader();

            // News single top info block
            if (document.querySelector('.top-info')) {
              newsTopInfo();
            }

            if(document.querySelector('.content-block video')) {
              newsVideo();
            }
            

            gsap
              .fromTo(
                data.next.container,
                {
                  opacity: 0,
                },
                {
                  ease: 'power1',
                  opacity: 1,
                  duration: TIMING_TRANSITION,
                }
              )
              .eventCallback('onComplete', function () {
                done();
              });
          },
          afterEnter() {
            video();
          },
          once() {
            video();
          }
        },
      ],
      views: [
        {
            namespace: 'NewsSingle',
            afterEnter: ()=>{
                NewsSingle();
            }
        },
        ]
    });
  }

  function pageLoad() {
    clientTabs();
    prepareAnimation();
    scrollReveal();
    mainSlider();
    contactMap();
    clientList();
    animation();
    setTimeout(() => {
      homeOpacity();
    }, 500);

    let header = document.querySelector('header');
    if (header) {
      header.classList.remove('stop-slider');
    }

    let width = window.innerWidth;

    function cookie() {
      let btn = document.querySelector('.accept-cookie');
      let block = document.querySelector('.cookie-block');
      if (!Cookies.get('cookie')) {
        block.classList.add('show');
      }
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          block.classList.remove('show');
          Cookies.set('cookie', 'true');
        });
      }
    }

    cookie();

    let items = document.querySelectorAll('.team-item');

    function showCard() {
      let cards = document.querySelectorAll('.card-wrapper');
      if (width > 1023) {
        items.forEach((elem, index) => {
          let itemIndex = index;
          elem.addEventListener('mouseover', function (event) {
            event.target.classList.add('hover');
            cards[itemIndex].classList.add('open');
          });
          elem.addEventListener('mouseout', function (event) {
            event.target.classList.remove('hover');
            cards[itemIndex].classList.remove('open');
          });
        });
      } else {
        let header = document.querySelector('.main-header');
        items.forEach((elem, index) => {
          let itemIndex = index;
          elem.addEventListener('click', function (event) {
            let activeLink = document.querySelector('.team-item.hover');
            if (activeLink) {
              activeLink.classList.remove('hover');
            }
            let activeCard = document.querySelector('.card-wrapper.open');
            if (activeCard) {
              activeCard.classList.remove('open');
            }
            event.target.classList.add('hover');
            cards[itemIndex].classList.add('open');

            if (width < 768) {
              header.classList.remove('transparent');
              header.classList.add('white');
              header.classList.add('card-open');
              let activeCard = document.querySelector('.card-wrapper.open');
              const ps = new PerfectScrollbar(activeCard);
              scrollLock.disablePageScroll();
            }
          });
          cards.forEach((elem) => {
            elem.addEventListener('click', function (event) {
              event.target.classList.remove('open');
              items[itemIndex].classList.remove('hover');
              header.classList.remove('white');
              header.classList.remove('card-open');
              header.classList.add('transparent');
              scrollLock.enablePageScroll();
            });
          });
        });
      }
    }

    if (items) {
      showCard();
    }
    const toTopBtn = document.querySelector('.to-top-btn');
    if (toTopBtn) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 200) {
          toTopBtn.style.opacity = '1';
        }
        if (window.scrollY < 200) {
          toTopBtn.style.opacity = '0';
        }
      });

      toTopBtn.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    }

    aboutHeader();

    if (document.querySelector('.loadmore')) {
      loadMore();
    }

    initMap();

    function initMap() {
      let mapEl = document.getElementById('map');
      if (!mapEl) {
        return;
      }
      const map = new google.maps.Map(mapEl, {
        center: { lat: 51.5136036, lng: -0.1480281 },
        zoom: 17,
        disableDefaultUI: true,
        styles: [
          {
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5',
              },
            ],
          },
          {
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#616161',
              },
            ],
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#f5f5f5',
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [
              {
                saturation: 45,
              },
              {
                lightness: 15,
              },
              {
                visibility: 'on',
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'labels',
            stylers: [
              {
                saturation: 40,
              },
              {
                lightness: 15,
              },
              {
                visibility: 'on',
              },
            ],
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#bdbdbd',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#eeeeee',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'on',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#757575',
              },
            ],
          },
          {
            featureType: 'poi.business',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e5e5e5',
              },
            ],
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff',
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#757575',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
              {
                color: '#dadada',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#616161',
              },
            ],
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e',
              },
            ],
          },
          {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e5e5e5',
              },
            ],
          },
          {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [
              {
                color: '#eeeeee',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#c9c9c9',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#9e9e9e',
              },
            ],
          },
        ],
      });
      let marker = new google.maps.Marker({
        position: { lat: 51.5136036, lng: -0.1480281 },
        map: map,
        title: 'Waring & McKenna Ltd',
        icon: window.location.protocol + '//' + window.location.host + '/wp-content/themes/my-theme/assets/img/marker.png',
      });
    }
  }

  function menu() {
    let menuBtn = document.querySelector('.menu-btn');
    let menuBlock = document.getElementById('menu');
    let header = document.querySelector('.main-header');
    let searchBlock = document.getElementById('search');
    let menuInner = menuBlock.querySelector('.menu-block__inner');
    const mainSliderNav = document.querySelector('.main-slider__nav');

    if (mainSliderNav) {
      updateNainSliderNavPositionOnNexus9();
    }
  
    function updateNainSliderNavPositionOnNexus9() {
      if (isAndroidOperatingSystem()) {
        if (window.innerHeight === 855 && window.innerWidth === 768) {
          mainSliderNav.style.top = '-100px';
        } else {
          mainSliderNav.style.top = 'initial';
        }
      }

      function isAndroidOperatingSystem() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
          return true;
        }

        return false;
      }
    }

    let canClickMenu = true;

    menuBtn.addEventListener('click', function (e) {
      e.preventDefault();

      if(canClickMenu){
        canClickMenu = false;

        if (searchBlock.classList.contains('open-menu')) {
          closeMenu('search');
          openMenu('menu');
        } else {
          if(menuBlock.classList.contains('open-menu')) {
            closeMenu('menu');
          } else {
            openMenu('menu');
          }
          
          if (header.classList.contains('show-menu')) {
            // header.style.backgroundColor = 'transparent';
          } else {
            menuBtn.classList.remove('active');

            if (header.classList.contains('white')) {
              setTimeout(() => {
                // header.style.backgroundColor = '#ffffff';
              }, 100);
            }
          }

          const footer = document.querySelector('.footer');
          footer.classList.toggle('footer--hidden');

          const ps = new PerfectScrollbar(menuInner);

          setTimeout(() => {
            header.addEventListener('click', handleHeaderClick);
          }, 0);
        }

      }

      setTimeout(() => {
        canClickMenu = true;
      }, 300);
      
    });

    hoverOnMenuBtn();

    menuBlock.addEventListener('click', (e) => {
      const container = document.querySelector('.main-container');
      const isLink = e.target.matches('a');

      if (!isLink) {
        closeMenu('menu');
      } else {
        header.style.backgroundColor = '';
      }
    });

    function hoverOnMenuBtn() {
      menuBtn.addEventListener('mouseover', () => {
        menuBtn.classList.add('active');
      });
      menuBtn.addEventListener('mouseout', () => {
        menuBtn.classList.remove('active');
      });
    }

    function handleHeaderClick(e) {
      const isLink = e.target.closest('a');

      if (menuBlock.classList.contains('open-menu') && !isLink) {
        closeMenu('menu');
        showFooter();
      }
    }

    function hideFooter() {
      const footer = document.querySelector('.footer');

      footer.classList.add('footer--hidden');
    }

    function showFooter() {
      const footer = document.querySelector('.footer');

      footer.classList.remove('footer--hidden');
    }
  }

  function search() {
    let searchBtn = document.querySelector('.search-btn');
    let searchBlock = document.getElementById('search');
    let menuBlock = document.getElementById('menu');
    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      
      if (menuBlock.classList.contains('open-menu')) {
        closeMenu('menu');
        openMenu('search');
      } else {
        if(searchBlock.classList.contains('open-menu')) {
          closeMenu('search');
        } else {
          openMenu('search');
        }
      }
    });
  }

  // News single top info block
  if (document.querySelector('.top-info')) {
    newsTopInfo();
  }

  // Gallery block
  if (document.querySelector('.gallery-img-two-vert')) {
    clientGallery();
  }

  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit **
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document**
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // We listen to the resize event**
  window.addEventListener('resize', () => {
    // We execute the same script as before**
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  // Update iframe video height on different breakepoints
  if (document.querySelector('.gallery-block')) {
    const iframes = document.querySelectorAll('.gallery-img-one-hor iframe');

    updateVideoHeight();

    window.addEventListener('load', updateVideoHeight);
    window.addEventListener('resize', updateVideoHeight);

    function updateVideoHeight() {
      const setHeith = (node, value) => (node.style.minHeight = value + 'px');

      iframes.forEach((iframe) => {
        if (window.innerWidth <= 375) {
          setHeith(iframe, 192);
        } else if (window.innerWidth <= 460) {
          setHeith(iframe, 200);
        } else if (window.innerWidth <= 768) {
          setHeith(iframe, 376);
        } else if (window.innerWidth <= 1024) {
          setHeith(iframe, 520);
        }
      });
    }
  }

  // Orientation modal
    orientationModal();


  document.addEventListener('click', (e)=>{
    if(e.target.closest('.logo-block__link')) {
      closeMenu('all');
    }
  });

  function openMenu(modal) {
    // console.log('openModal ' + modal);

    let searchBlock = document.getElementById('search'),
        menuBlock = document.getElementById('menu'),
        header = document.querySelector('.main-header'),
        container = document.querySelector('.main-container');

    if(modal == 'menu') {
      menuBlock.classList.add('open-menu');
      searchBlock.classList.remove('open-menu');
    } else {
      searchBlock.classList.add('open-menu');
      menuBlock.classList.remove('open-menu');
    }

    header.classList.add('show-menu');
    container.classList.add('show-menu');
    scrollLock.disablePageScroll();
  }

  function closeMenu(modal) {
    // console.log('closeMenu ' + modal);
    
    let searchBlock = document.getElementById('search'),
        menuBlock = document.getElementById('menu'),
        header = document.querySelector('.main-header'),
        container = document.querySelector('.main-container');

    if(modal == 'menu') {
      menuBlock.classList.remove('open-menu');
    } else if (modal == 'search') {
      searchBlock.classList.remove('open-menu');
    } else {
      menuBlock.classList.remove('open-menu');
      searchBlock.classList.remove('open-menu');
    }
    
    header.classList.remove('show-menu');
    container.classList.remove('show-menu');
    scrollLock.enablePageScroll();
  }

  
  

};
